var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUnion = function SvgUnion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 50,
    viewBox: "0 0 40 50",
    width: 40,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m20 50c-2.2091 0-4-1.7909-4-4v-42c0-2.20914 1.7909-4 4-4s4 1.79086 4 4v42c0 2.2091-1.7909 4-4 4zm-16 0c-2.20914 0-4-1.7909-4-4v-12c0-2.2091 1.79086-4 4-4s4 1.7909 4 4v12c0 2.2091-1.79086 4-4 4zm28-4c0 2.2091 1.7909 4 4 4s4-1.7909 4-4v-32c0-2.2091-1.7909-4-4-4s-4 1.7909-4 4z",
    fill: "#1dbadf",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/union.be70c609.svg";
export { ForwardRef as ReactComponent };